<div class="card p-3">
  <div class="row">
    <div class="col-12 text-primary font-weight-bold mb-1 h6">
      {{ "DATA_STUDIO.DATA_PARAMETERS.TITLE" | translate }}
    </div>
    <div class="col-12 text-primary mb-4">
    </div>
  </div>
  <div class="d-flex justify-content-between">
    <div class="data-assets-container">
      <div class="col-12 text-primary font-weight-bold mb-2">
        {{ "DATA_STUDIO.DATA_PARAMETERS.ASSETS_SETTINGS" | translate }}
      </div>
      <!--Aggregation Method -->
      <div class="col-12 mb-3">
        <div class="d-flex justify-content-between">
          <span class="text-grey">{{"DATA_STUDIO.DATA_PARAMETERS.AGGREGATION_METHOD" | translate}}</span>
        </div>
        <lib-select
          [options]="aggregationOptions.titles"
          [label]="selectedAggregationName"
          [border]="'custom-border'"
          [classes]="'font-size-normal-small text-primary h-100'"
          [notBold]="true"
          [fullWidth]="true"
          [itemClasses]="'font-size-normal-small'"
          [container]="''"
          (selectedChanged)="selectAggregation($event)">
        </lib-select>
      </div>
      <!--Select Park -->
      @if (selectedAggregation === 'park' || selectedAggregation === 'turbine') {
        <div
          class="col-12 mb-3">
          <div class="d-flex justify-content-between">
            <span class="text-grey">{{ "DATA_STUDIO.DATA_PARAMETERS.SELECT_PARK" | translate }}</span>
          </div>
          @if (dataParks) {
            <lib-select
              [options]="dataParksNames"
              [label]="parkSelected?.fe_name"
              [border]="'custom-border'"
              [classes]="'font-size-normal-small text-primary h-100'"
              [notBold]="true"
              [fullWidth]="true"
              [itemClasses]="'font-size-normal-small'"
              [doNotTranslate]="true"
              [container]="''"
              (selectedChanged)="selectPark($event)">
            </lib-select>
          }
        </div>
      }
      <!--Select Turbines -->
      @if (selectedAggregation === 'park' && parkSelected) {
        <div
          class="col-12 mb-3">
          <div class="d-flex justify-content-between">
            <span class="text-grey">{{ "DATA_STUDIO.DATA_PARAMETERS.SELECT_TURBINES" | translate }}</span>
          </div>
          <app-data-assets
            [park]="parkSelected"
            [aggregationMethod]="'park'"
            (selectedParksTurbines)="selectedAssetTurbines($event)">
          </app-data-assets>
        </div>
      }
      <!--Select One Turbine -->
      @if (selectedAggregation === 'turbine') {
        <div class="col-12 mb-3">
          <div class="d-flex justify-content-between">
            <span class="text-grey">{{ "DATA_STUDIO.DATA_PARAMETERS.SELECT_TURBINE" | translate }}</span>
          </div>
          <lib-select
            [options]="turbinesList"
            [label]="turbineSelection"
            [border]="'custom-border'"
            [classes]="'font-size-normal-small text-primary h-100'"
            [notBold]="true"
            [fullWidth]="true"
            [itemClasses]="'font-size-normal-small'"
            [doNotTranslate]="true"
            [container]="''"
            (selectedChanged)="selectedOneTurbine($event)">
          </lib-select>
        </div>
      }
      <!--Select Assets -->
    </div>
    @if (signalGroupArray.length > 0) {
      <div
        class="d-flex flex-column available-signals-container">
        <div class="text-primary font-weight-bold mb-2">
          {{ "DATA_STUDIO.DATA_PARAMETERS.AVAILABLE_SIGNALS" | translate }}
        </div>
        @for (signalGroup of signalGroupArray; track $index) {
          <div
            class="border rounded w-100 p-2 mb-3 text-primary">
            <div class="d-flex justify-content-between">
              <mat-checkbox
                [(ngModel)]="signalGroup.signalGroupName.checked"
                (change)="selectAllSignalsByGroup(signalGroup.signalGroupName.name)">
                <b>{{ signalGroup.signalGroupName.name | translate | titlecase }}</b>
              </mat-checkbox>
              <span>
                <small>
                  {{ signalGroup.totalSignalSelected }} {{ "COMMON.OF" | translate }}
                  {{ signalGroup.signals.length }}
                </small>
              </span>
            </div>
            <div>
              <hr class="my-1" />
            </div>
            <div class="row">
              @for (signals of signalGroup.signals; track $index; let i = $index) {
                <div
                  class="col-4 pr-2">
                  <mat-checkbox
                    [(ngModel)]="signals.checked"
                    [value]="signals.value"
                    (change)="checkSelectedSignals()">
                    <span [appCustomTooltip]="tooltipTemplate">{{ signals.name | translate }}</span>
                  </mat-checkbox>
                  <ng-template #tooltipTemplate>
                    <div>
                      <b>{{ signals.name | translate }}</b
                        ><br />
                        {{ signals.value }}
                        <hr class="my-1" />
                        {{ signals.description | translate }}<br />
                      </div>
                    </ng-template>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
